module.exports = mapSymbol

var map = require('./map')

function mapSymbol(currencyCode) {
  if (map.hasOwnProperty(currencyCode)) {
    return map[currencyCode]
  } else {
    return '?'
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/currency-symbol-map/currency-symbol-map.js
// module id = 385
// module chunks = 0